var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "route-projects" }, [
    _c(
      "div",
      { staticClass: "padding-box" },
      [
        _c(
          "cms-heading",
          {
            staticClass: "page-heading",
            attrs: {
              level: "1",
              title: "Projecten",
              icon: "magicon-folder-opened",
            },
          },
          [
            _c(
              "cms-button",
              {
                attrs: {
                  color: "positive",
                  icon: "magicon-plus",
                  route: "project-add",
                },
              },
              [_vm._v("Project toevoegen")]
            ),
          ],
          1
        ),
        _c(
          "cms-heading",
          { attrs: { level: "2", title: "Alle projecten" } },
          [
            _c("cms-searchbar", {
              model: {
                value: _vm.searchQuery,
                callback: function ($$v) {
                  _vm.searchQuery = $$v
                },
                expression: "searchQuery",
              },
            }),
          ],
          1
        ),
        _c("cms-pagination", {
          staticClass: "top-pagination",
          attrs: { pages: _vm.pageCount },
          model: {
            value: _vm.page,
            callback: function ($$v) {
              _vm.page = $$v
            },
            expression: "page",
          },
        }),
        _c(
          "cms-table",
          {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              clickable: "true",
              "item-count": _vm.totalItems,
              "items-per-page": _vm.itemsPerPage,
              page: _vm.page,
              offset: _vm.offset,
              placeholder: _vm.projects && !_vm.projects.items.length,
            },
            on: { page: _vm.switchPage },
          },
          [
            _c(
              "cms-table-header",
              [
                _c(
                  "cms-th",
                  {
                    attrs: { field: "title" },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  },
                  [_vm._v("Project")]
                ),
                _c(
                  "cms-th",
                  {
                    attrs: { field: "code" },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  },
                  [_vm._v("Project code")]
                ),
                _c(
                  "cms-th",
                  {
                    attrs: { field: "createdAt" },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  },
                  [_vm._v("Aangemaakt op")]
                ),
                _c("cms-th"),
              ],
              1
            ),
            _vm._l((_vm.projects || {}).items, function (project) {
              return _c(
                "tr",
                {
                  on: {
                    click: function ($event) {
                      return _vm.navigateProjectEdit(project.id)
                    },
                  },
                },
                [
                  _c("td", [_vm._v(_vm._s(project.title))]),
                  _c("td", [_vm._v(_vm._s(project.code))]),
                  _c("td", [
                    _vm._v(_vm._s(_vm._f("date")(project.createdAt, "LLL"))),
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "actions",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("cms-link", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Wijzigen",
                            expression: "'Wijzigen'",
                          },
                        ],
                        attrs: { icon: "img icon-table-pencil-dark" },
                        on: {
                          click: function ($event) {
                            return _vm.navigateProjectEdit(project.id)
                          },
                        },
                      }),
                      _c("cms-link", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Verwijderen",
                            expression: "'Verwijderen'",
                          },
                        ],
                        attrs: { icon: "img icon-table-cross-dark" },
                        on: {
                          click: function ($event) {
                            return _vm.onDeleteProject(project.id)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }